import { useEffect, useState } from 'react';
import { Switch } from '../../components/Switch';
import { api, type NoticeKind } from '../../lib/api';
import { useStore } from '../../store/StoreProvider';
import { SettingsBlock } from './SettingsBlock';

// Impostazioni › Notifiche (tela, artboard 38): quali eventi diventano notifica. Spento un tipo,
// non compare più nella pagina Notifiche né nel pallino del menu.
const KINDS: { id: NoticeKind; label: string; hint: string }[] = [
  {
    id: 'waiting',
    label: 'Aspetta te',
    hint: 'Una sessione chiede una risposta o un chiarimento.',
  },
  { id: 'completed', label: 'Conclusa', hint: 'Una sessione è finita.' },
  { id: 'failed', label: 'Si è fermata', hint: 'Una sessione è fallita.' },
  { id: 'anomaly', label: 'Presa da memo', hint: 'Pianifica ha preso un’anomalia da lavorare.' },
  {
    id: 'tools',
    label: 'Strumento da ricollegare',
    hint: 'Un account collegato (per esempio Gmail) non è più autorizzato.',
  },
];

export function NotificationsTab() {
  const { toast } = useStore();
  const [kinds, setKinds] = useState<NoticeKind[] | null>(null);
  useEffect(() => {
    api
      .notificationKinds()
      .then((r) => setKinds(r.kinds))
      .catch(() => setKinds(null));
  }, []);

  const toggle = (id: NoticeKind, on: boolean) => {
    if (!kinds) return;
    const next = on ? [...kinds, id] : kinds.filter((k) => k !== id);
    setKinds(next);
    api
      .setNotificationKinds(next)
      .then((r) => setKinds(r.kinds))
      .catch((e: Error) => toast({ kind: 'danger', title: 'Non salvato', body: e.message }));
  };

  return (
    <SettingsBlock
      over="Notifiche"
      title="Quali eventi diventano notifica"
      hint="Le sceglie l’amministratore e valgono per tutti i profili."
    >
      <div style={{ display: 'grid', gap: 14 }}>
        {KINDS.map((k) => (
          <Switch
            key={k.id}
            label={k.label}
            hint={k.hint}
            checked={kinds?.includes(k.id) ?? false}
            disabled={kinds === null}
            onChange={(on) => toggle(k.id, on)}
          />
        ))}
      </div>
    </SettingsBlock>
  );
}
